export default __webpack_public_path__ + "static/modal01_01-pc-7e7090f765dc6253245365cf6dfd1ed1.png";